module.exports = __webpack_public_path__ + "media/src/images/icons/alert-triangle-91db8d516ff61653efbdc94bdba8f64f.svg";